<template>
  <el-dialog title="详情" :visible.sync="visible" width="72%">
    <el-form :model="data" ref="addForm" label-width="90px">
      <el-form-item label="内容标题:" prop="name">{{data.title}}</el-form-item>
      <el-form-item label="类型:" prop="name">{{data.contentType === 1 ? '图文' : '视频'}}</el-form-item>
      <el-form-item label="封面图:" prop="name">
        <el-image v-for="item in data.headPicUrlList" style="width: 100px;margin-right: 5px"
                  :src="item" :preview-src-list="[item]" fit="contain"/>
      </el-form-item>
      <el-form-item label="视频文件:" prop="name" v-if="data.contentType === 2">
        <video v-if="data.videoUrl" controls="controls" preload  style="width: 300px; height: 300px;background:#eee;">
          <source :src="data.videoUrl" type=".mp4,.mov,.avi,.flv">
        </video>
      </el-form-item>
      <el-form-item v-if="data.articleType === 1" label="标签:" prop="name">{{data.tags}}</el-form-item>
      <el-form-item label="文章详情:" prop="content" v-if="data.contentType === 1">
        <el-card shadow="never">
          <div v-html="data.content"></div>
        </el-card>
      </el-form-item>
      <el-form-item label="简介:" prop="introduction" v-if="data.contentType === 2">
        {{data.introduction}}
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveFile, queryFolderList, articleDetail } from "@/api/saas/package";
import { mapState } from "vuex";
import FileUpload from "@/views/crm/components/fileUpload";

export default {
  name: "AddClueDialog",
  components: {
    FileUpload
  },
  props: {},
  data() {
    return {
      title: '',
      disabled: false,
      visible: false,
      folderList: [],
      fileObjs: [],
      rules: {
        fileName: [
          { required: true, message: "请输入文件名称", trigger: "change" }
        ],
        folderId: [{ required: true, message: "请选择文件夹", trigger: "change" }]
      },
      data: {
        fileName: null,
        folderName: null,
        description: null,
        fileSize: null,
        fileType: '',
        fileUrl: null,
        folderId: null,
      }
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  methods: {
    open(data) {
      this.visible = true;
      this.articleId = data.articleId
      this.articleDetail()
    },
    articleDetail() {
      articleDetail({ articleId: this.articleId })
        .then(response => {
          this.$nextTick(() => {
            this.data = response.data
          })
        })
        .catch(error => {});
    },
  }
};
</script>
